/* eslint-disable */
export const checkCampaignProducts = order => order.items.some(item => item.campaign);
